import React, { Suspense } from "react";
import { IconButton } from "@mui/material";
import menus from "./menus";
import JumboVerticalNavbar from "@jumbo/components/JumboVerticalNavbar/JumboVerticalNavbar";
import { DrawerHeader } from "@jumbo/components/JumboLayout/style";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import useJumboSidebarTheme from "@jumbo/hooks/useJumboSidebarTheme";
import { SIDEBAR_STYLES, SIDEBAR_VIEWS } from "@jumbo/utils/constants/layout";
import Logo from "../../../../shared/Logo";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Zoom from "@mui/material/Zoom";
import Div from "@jumbo/shared/Div";
import SidebarSkeleton from "./SidebarSkeleton";
import AccountPreview from "./AccountPreview";
import { useSelector } from "react-redux";

const normalizePermissionKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const Sidebar = () => {
  console.log("Menus:", menus);
  const { authUserData } = useSelector((state) => state.CommonReducer);
  const isSysAdmin = String(authUserData?.is_sys_admin) === "1";
  const normalizedPermissions = (authUserData?.user_permissions || []).map(
    normalizePermissionKey
  );
  const hasAudiencePixelAccess =
    isSysAdmin ||
    normalizedPermissions.includes("enable_audience_pixel_access");
  const hasLocationSegmentAccess =
    isSysAdmin ||
    authUserData?.user_permissions?.includes("enable_location_segments") ===
      true;
  const hasGeoIntelAccess =
    isSysAdmin ||
    (authUserData?.user_permissions?.includes("enable_geointel") === true &&
      String(authUserData?.geointel_enabled) === "1");

  const filterLeftSideMenu = () => {
    let modifiedMenus = [];
    for (let k = 0; k < menus.length; k++) {
      let menuObj = {
        ...menus[k],
        children: Array.isArray(menus[k]?.children)
          ? menus[k].children.map((child) => ({ ...child }))
          : menus[k]?.children,
      };

      if (menuObj.key == "home") {
        let home_children = menuObj.children;
        let modifiedChildren = [];
        for (let n = 0; n < home_children.length; n++) {
          let child = home_children[n];
          if (
            child.uri == "/home/dashboard" &&
            authUserData.is_sys_admin == "0" &&
            authUserData?.user_permissions?.includes(
              "show_consent_dashboard_tab"
            ) == false
          ) {
            //do not include
          } else {
            modifiedChildren.push(child);
          }
        }
        menuObj.children = modifiedChildren;
      }

      if (
        menuObj.key == "consent_mgmt" &&
        authUserData.is_sys_admin == "0" &&
        authUserData.user_permissions.includes("show_consent_management_tab") ==
          false &&
        authUserData.user_permissions.includes("show_consent_total_requests") ==
          false &&
        authUserData.user_permissions.includes("show_consent_open_requests") ==
          false
      ) {
        continue;
      } else if (menuObj.key == "consent_mgmt") {
        let consent_mgmt_children = menuObj.children;
        let modifiedChildren = [];
        for (let n = 0; n < consent_mgmt_children.length; n++) {
          let child = consent_mgmt_children[n];
          if (
            child.uri == "/consent/openrequest" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions.includes(
              "show_consent_open_requests"
            ) == false
          ) {
            //do not include
          } else if (
            child.uri == "/consent/requesthistory" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions.includes(
              "show_consent_total_requests"
            ) == false
          ) {
            //do not include
          } else {
            modifiedChildren.push(child);
          }
        }
        menuObj.children = modifiedChildren;
      }

      if (menuObj.key == "audience_mgmt" && !hasLocationSegmentAccess && !hasGeoIntelAccess) {
        continue;
      } else if (menuObj.key == "audience_mgmt") {
        let consent_mgmt_children = menuObj.children;
        let modifiedChildren = [];
        for (let n = 0; n < consent_mgmt_children.length; n++) {
          let child = consent_mgmt_children[n];
          if (
            (child.uri == "/audience/segments" ||
              child.uri == "/targeting/createaudience" ||
              child.uri == "/targeting/editaudiencesegment") &&
            hasLocationSegmentAccess == false
          ) {
            //do not include
          } else if (
            child.uri == "/audience/geointel" &&
            hasGeoIntelAccess == false
          ) {
            //do not include — GeoIntel requires role permission plus per-user access
          } else {
            modifiedChildren.push(child);
          }
        }
        if (modifiedChildren.length === 0) {
          continue;
        }
        menuObj.children = modifiedChildren;
      }

      if (
        (authUserData?.user_assoc_profiles?.includes("advertiser") == false &&
          authUserData.is_sys_admin == "0" &&
          authUserData.user_permissions?.includes("show_advertiser_reporting") == false &&
          menuObj.key == "campaign_mgmt") ||
        (authUserData?.user_assoc_profiles?.includes("publisher") == false &&
          authUserData.is_sys_admin == "0" &&
          authUserData.user_permissions?.includes("show_publisher_reporting") == false &&
          menuObj.key == "publisher_mgmt") ||
        (authUserData?.user_assoc_profiles?.includes("bidder") == false &&
          authUserData.is_sys_admin == "0" &&
          authUserData.user_permissions?.includes("show_bidder_reporting") == false &&
          menuObj.key == "bidder_mgmt") ||
        (menuObj.key == "admin_mgmt" &&
          authUserData.is_sys_admin == "0" &&
          authUserData.enable_account_creation == "0" &&
          authUserData.is_adv_admin == "0" &&
          authUserData.is_pub_admin == "0")
      ) {
        continue;
      }

      if (menuObj.key == "report") {
        let report_children = menuObj.children;
        let reportChildren = [];
        if (
          authUserData.is_sys_admin == "1" ||
          authUserData.dashboard_enabled == "1"
        ) {
          for (let l = 0; l < report_children.length; l++) {
            let child = report_children[l];
            if (
              child.uri == "report/analyticsdashboard" &&
              authUserData.is_sys_admin != "1" &&
              authUserData.dashboard_enabled != "0"
            ) {
              //do not include
            } else {
              reportChildren.push(child);
            }
          }
        }
        if (reportChildren.length > 0) {
          menuObj.children = reportChildren;
        } else {
          //To remove entire tab
          continue;
        }
      }

      if (menuObj.key == "admin_mgmt") {
        let admin_mgmt_children = menuObj.children;
        let modifiedChildren = [];
        for (let n = 0; n < admin_mgmt_children.length; n++) {
          let child = admin_mgmt_children[n];
          if (
            child.uri == "/system/managecompanies" &&
            authUserData.is_sys_admin == "0"
          ) {
            //do not include
          } else if (
            child.uri == "/system/manageaccounts" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.enable_account_creation == "0"
          ) {
            //do not include
          } else if (
            child.uri == "/system/manageusers" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.is_adv_admin == "0" &&
            authUserData.is_pub_admin == "0"
          ) {
            //do not include
          } else if (
            child.uri == "/system/manageroles" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.is_adv_admin == "0" &&
            authUserData.is_pub_admin == "0"
          ) {
            //do not include
          } else if (
            child.uri == "/system/managethemes" &&
            authUserData.is_sys_admin == "0"
          ) {
            //do not include
          } else if (
            child.uri == "/system/managedashboarduserroles" &&
            authUserData.is_sys_admin == "0"
          ) {
            //do not include
          } else {
            modifiedChildren.push(child);
          }
        }
        menuObj.children = modifiedChildren;
      }

      if (menuObj.key == "publisher_mgmt") {
        let pub_mgmt_children = menuObj.children;
        let pubmodifiedChildren = [];
        for (let l = 0; l < pub_mgmt_children.length; l++) {
          let child = pub_mgmt_children[l];
          if (
            child.uri == "/publisher/managepublishers" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.is_pub_admin == "0"
          ) {
            //do not include
          } else if (
            child.uri == "/publisher/supplydeals" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes(
              "enable_supply_dealids_creation"
            ) == false
          ) {
            //do not include
          } else if (
            child.uri == "/publisher/analyticsdashboard" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.dashboard_enabled == 0
          ) {
            //do not include
          } else if (
            child.uri == "/publisher/responsesample" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes("show_request_samples") ==
              false
          ) {
            //do not include
          } else if (
            child.uri == "/publisher/reporting" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes("show_publisher_reporting") == false
          ) {
            //do not include
          } else if (
            child.uri == "/targeting/supplyanalysis" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes("show_supply_analysis") == false
          ) {
            //do not include
          } else {
            pubmodifiedChildren.push(child);
          }
        }
        menuObj.children = pubmodifiedChildren;
      }
      if (menuObj.key == "campaign_mgmt") {
        let camp_mgmt_children = menuObj.children;
        let campmodifiedChildren = [];
        for (let i = 0; i < camp_mgmt_children.length; i++) {
          let child = camp_mgmt_children[i];
          if (
            child.uri == "/advertiser/manageadvertisers" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.is_adv_admin == "0"
          ) {
            //do not include
          } else if (
            child.uri == "/targeting/campaigns" &&
            authUserData.is_sys_admin == "0" &&
            authUserData?.user_assoc_profiles?.includes("advertiser") == false
          ) {
            //do not include
          } else if (
            child.uri == "/advertiser/analyticsdashboard" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.dashboard_enabled == 0
          ) {
            //do not include
          } else if (
            child.uri == "/advertiser/audiencepixels" &&
            hasAudiencePixelAccess == false
          ) {
            //do not include
          } else if (
            child.uri == "/advertiser/supplydashboard" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.supply_dashboard_enabled == 0
          ) {
            //do not include
          } else if (
            child.uri == "/targeting/targetinggroups" &&
            authUserData.is_sys_admin == "0" &&
            (authUserData?.user_assoc_profiles?.includes("advertiser") ==
              false ||
              authUserData.user_permissions?.includes(
                "enable_target_groups_creation"
              ) == false)
          ) {
            //do not include
          } else if (
            child.uri == "/advertiser/reporting" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes("show_advertiser_reporting") == false
          ) {
            //do not include
          } else if (
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes("hide_campaign_creation") == true &&
            (child.uri == "/targeting/campaigns" ||
             child.uri == "/advertiser/manageadvertisers" ||
             child.uri == "/targeting/targetinggroups" ||
             child.uri == "/advertiser/audiencepixels")
          ) {
            //do not include - hide campaign creation items for reporting-only users
          } else {
            campmodifiedChildren.push(child);
          }
        }
        menuObj.children = campmodifiedChildren;
      }

      if (menuObj.key == "bidder_mgmt") {
        let bidder_mgmt_children = menuObj.children;
        let biddermodifiedChildren = [];
        for (let i = 0; i < bidder_mgmt_children.length; i++) {
          let child = bidder_mgmt_children[i];
          if (
            child.uri == "/bidder/analyticsdashboard" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.dashboard_enabled == 0
          ) {
            //do not include
          } else if (
            child.uri == "/bidder/supplydashboard" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.supply_dashboard_enabled == 0
          ) {
            //do not include
          } else if (
            child.uri == "/bidder/responsesample" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes("show_request_samples") ==
              false
          ) {
            //do not include
          } else if (
            child.uri == "/bidder/manageprivatemarketplace" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes("show_deals") == false
          ) {
            //do not include
          } else if (
            child.uri == "/bidder/reporting" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes("show_bidder_reporting") == false
          ) {
            //do not include
          } else {
            biddermodifiedChildren.push(child);
          }
        }
        menuObj.children = biddermodifiedChildren;
      }

      if (
        menuObj.key == "payments" &&
        authUserData.is_sys_admin == "0" &&
        authUserData.user_permissions.includes("enable_make_payment") ==
          false &&
        authUserData.user_permissions.includes("show_payment_history_tab") ==
          false
      ) {
        continue;
      } else if (menuObj.key == "payments") {
        let payments_mgmt_children = menuObj.children;
        let paymentmodifiedChildren = [];
        for (let i = 0; i < payments_mgmt_children.length; i++) {
          let child = payments_mgmt_children[i];
          if (
            child.uri == "/payments/addpayment" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes("enable_make_payment") ==
              false
          ) {
            //do not include
          } else if (
            child.uri == "/payments/paymenthistory" &&
            authUserData.is_sys_admin == "0" &&
            authUserData.user_permissions?.includes(
              "show_payment_history_tab"
            ) == false
          ) {
            //do not include
          } else {
            paymentmodifiedChildren.push(child);
          }
        }
        menuObj.children = paymentmodifiedChildren;
      }

      modifiedMenus.push(menuObj);
    }
    return modifiedMenus;
  };

  const finalMenus = filterLeftSideMenu();

  return (
    <React.Fragment>
      <SidebarHeader />
      <JumboScrollbar autoHide autoHideDuration={200} autoHideTimeout={500}>
        <Suspense
          fallback={
            <Div
              sx={{
                display: "flex",
                minWidth: 0,
                alignItems: "center",
                alignContent: "center",
                px: 3,
              }}
            >
              <SidebarSkeleton />
            </Div>
          }
        >
          {/* <AccountPreview /> */}
          <JumboVerticalNavbar translate items={finalMenus} />
        </Suspense>
      </JumboScrollbar>
    </React.Fragment>
  );
};

const SidebarHeader = () => {
  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
  const { sidebarTheme } = useJumboSidebarTheme();

  const isMiniAndClosed = React.useMemo(() => {
    return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
  }, [sidebarOptions.view, sidebarOptions.open]);

  return (
    <React.Fragment>
      {sidebarOptions?.style !== SIDEBAR_STYLES.CLIPPED_UNDER_HEADER && (
        <DrawerHeader>
          <Logo mini={isMiniAndClosed} mode={sidebarTheme.type} />
          {sidebarOptions?.view !== SIDEBAR_VIEWS.MINI && (
            <Zoom in={sidebarOptions?.open}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                sx={{ ml: 0, mr: -1.5, alignSelf:'flex-start !important' }}
                onClick={() => setSidebarOptions({ open: false })}
              >
                <MenuOpenIcon />
              </IconButton>
            </Zoom>
          )}
        </DrawerHeader>
      )}
    </React.Fragment>
  );
};

export default Sidebar;
